<app-header class="header-fixed" *ngIf="appLoaded"></app-header>

<app-menu-sidebar *ngIf="appLoaded" class="position-fixed"></app-menu-sidebar>

<div class="">
    <div *ngIf="appLoaded" class="content-wrapper">
        <router-outlet></router-outlet>
    </div>
</div>

<app-footer class="footer-fixed" *ngIf="appLoaded"></app-footer>

<div id="sidebar-overlay" *ngIf="appLoaded" (click)="onToggleMenuSidebar()"></div>
